import React, { useState, useEffect, useCallback } from 'react';
import { Snackbar, Alert } from '@mui/material';
import {
  registerGlobalErrorHandler,
  unregisterGlobalErrorHandler,
} from '../api';

// 全局消息状态管理
let showSnackbarFn = null;

export function showSuccess(message) {
  if (showSnackbarFn) showSnackbarFn(message, 'success');
}

export function showError(message) {
  if (showSnackbarFn) showSnackbarFn(message, 'error');
}

export function showWarning(message) {
  if (showSnackbarFn) showSnackbarFn(message, 'warning');
}

export function showInfo(message) {
  if (showSnackbarFn) showSnackbarFn(message, 'info');
}

export default function GlobalSnackbar() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('error');

  const handleMessage = useCallback((msg, type = 'error') => {
    setMessage(msg);
    setSeverity(type);
    setOpen(true);
  }, []);

  useEffect(() => {
    showSnackbarFn = handleMessage;
    registerGlobalErrorHandler((msg) => handleMessage(msg, 'error'));
    return () => {
      showSnackbarFn = null;
      unregisterGlobalErrorHandler();
    };
  }, [handleMessage]);

  const handleClose = (_event, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

  // 根据类型设置不同的自动关闭时间
  const autoHideDuration = severity === 'error' ? 5000 : 3000;

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        variant="filled"
        sx={{
          width: '100%',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
